<template>
  <div class="general-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'GeneralLayout'
}
</script>
